var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bloco",class:{ total: _vm.tipo == '0' },style:({ backgroundColor: _vm.COLOR.dados.cor })},[_vm._v(" "+_vm._s(_vm._f("zeroNaFrente")(_vm.item.length))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }